var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { QueryObserver, MutationObserver } from '@tanstack/query-core';
/**
 * This service provides adapters for interacting with the QueryClient instance from Ember code.
 */
let EmberQuery = (_class = class EmberQuery extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "queryClient", _descriptor, this);
  }
  get queryClientInstance() {
    return this.queryClient.instance;
  }

  // Returns a Promise that resolves with the query data or error. Does NOT create an observer.
  // Equivalent to https://tanstack.com/query/v4/docs/reference/QueryClient/#queryclientensurequerydata
  readQuery(queryDef) {
    return this.queryClientInstance.ensureQueryData(queryDef);
  }

  // Creates an observer for the given query definition. Invokes callback when query status changes
  // Callback receives same data returned by useQuery hook (https://tanstack.com/query/v4/docs/framework/react/reference/useQuery)
  observeQuery(queryDef, callback) {
    const observer = new QueryObserver(this.queryClientInstance, queryDef);
    const unsubscribe = observer.subscribe(callback);
    callback(observer.getOptimisticResult({
      ...queryDef,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      useErrorBoundary: false
    }));
    return unsubscribe;
  }

  // Combines readQuery & observeQuery - returns a Promise with query data while also creating an observer
  async readAndObserveQuery(queryDef, callback, hasObserver) {
    const data = await this.readQuery(queryDef);
    let unsubscribe;
    if (!hasObserver) {
      // Subscribe to changes if we haven't already
      unsubscribe = this.observeQuery({
        ...queryDef,
        refetchOnMount: false
      }, callback);
    }
    return {
      data,
      unsubscribe
    };
  }

  // Creates a Mutation observer, invokes callback when the status changes.
  // Returns a mutate function that should be called in Ember with the mutation variables
  // Callback receives same data returned by useMutation hook (https://tanstack.com/query/v4/docs/framework/react/reference/useMutation)
  mutateQuery(queryDef, callback) {
    const observer = new MutationObserver(this.queryClientInstance, queryDef);
    if (callback) {
      observer.subscribe(callback);
    }
    return {
      mutate: observer.mutate
    };
  }

  // Performs mutateQuery and immediately invokes the mutate function with passed in variables.
  // Returns a promise with the result of the mutation.
  // Similar to the mutateAsync fn returned by useMutation hook (https://tanstack.com/query/v4/docs/framework/react/reference/useMutation)
  mutateQueryAsync(queryDef, callback, variables) {
    const {
      mutate
    } = this.mutateQuery(queryDef, callback);
    return mutate(variables);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "queryClient", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "observeQuery", [action], Object.getOwnPropertyDescriptor(_class.prototype, "observeQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mutateQuery", [action], Object.getOwnPropertyDescriptor(_class.prototype, "mutateQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mutateQueryAsync", [action], Object.getOwnPropertyDescriptor(_class.prototype, "mutateQueryAsync"), _class.prototype)), _class);
export { EmberQuery as default };